export function removeItemInArray(array: any[], item: any): void {
    const index = array.indexOf(item);
    if (index > -1) {
        array.splice(index, 1);
    }
}

/**
 * Filters arrayA and arrayB from elements which are in both arrays
 * and returns concatenated results from filtering.
 */
export function arraySymmetricDiff<T>(arrayA: T[], arrayB: T[]): Array<T> {
    return arrayA
        .filter(item => !arrayB.includes(item))
        .concat(arrayB.filter(item => !arrayA.includes(item)));
}

/**
 * Filters arrayA and arrayB from elements which are in both arrays and have the same key (e.g. id)
 * and returns concatenated results from filtering.
 */
export function arraySymmetricDiffByKey<T>(key: keyof T, arrayA: T[], arrayB: T[]): Array<T> {
    const groupA = arrayA.map(item => item[key]);
    const groupB = arrayB.map(item => item[key]);
    const diffKeys = arraySymmetricDiff(groupA, groupB);
    return [...arrayA, ...arrayB].filter(item => diffKeys.includes(item[key]));
}

export function base64ToArrayBuffer(dataURI: string): ArrayBuffer {
    const binaryString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(binaryString.length);
    const bytes = new Uint8Array(ab);

    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

type ItemWithId = { id: string };

export function removeItemWithId<T extends ItemWithId>(array: T[], idToFind: string | string[]): T[] {
    const ids = Array.isArray(idToFind) ? idToFind : [idToFind];
    return array.filter(({ id }) => !ids.includes(id));
}

export function distinctArrayById<T extends ItemWithId>(arr: T[]): T[] {
    const newArray: T[] = [];
    for (const item of arr) {
        const itemExists = newArray.some(a => a.id === item.id);
        if (!itemExists) {
            newArray.push(item);
        }
    }

    return newArray;
}
